function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
//
/* eslint-disable react/no-unused-prop-types, react/forbid-prop-types */

/**
 * A simple wrapper around react-virtualized-select to offer consistent UI.
 * See https://github.com/bvaughn/react-virtualized-select for more details.
 * Update this component if more features needs to be introduced.
 */
import * as React from 'react';
import PropTypes from 'prop-types';

// TODO(Audrey): FRONT-760
// import 'css!react-select/dist/react-select.css';
// import 'css!react-virtualized/styles.css';
// import 'css!react-virtualized-select/styles.css';

// $FlowFixMe
import VirtualizedSelect from 'react-virtualized-select';
// $FlowFixMe
import { Creatable as ReactSelectCreatable, AsyncCreatable } from 'react-select';
import generateUUID from "../../utils/generateUUID";

// Creatable ref warning work-around:
// Reference: https://github.com/JedWatson/react-select/issues/2181#issuecomment-384566053
var Creatable = /*#__PURE__*/function (_React$Component) {
  function Creatable() {
    _classCallCheck(this, Creatable);
    return _callSuper(this, Creatable, arguments);
  }
  _inherits(Creatable, _React$Component);
  return _createClass(Creatable, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ReactSelectCreatable, this.props);
    }
  }]);
}(React.Component);
var Select = /*#__PURE__*/function (_React$Component2) {
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _callSuper(this, Select, [props]);
    _defineProperty(_this, "props", void 0);
    _defineProperty(_this, "state", void 0);
    _defineProperty(_this, "handleOnChange", function (option) {
      var onChange = _this.props.onChange;
      if (onChange) {
        if (option == null) {
          onChange(option, 0);
        } else {
          onChange(option, _this.getIndex(option));
        }
      }
    });
    _defineProperty(_this, "getIndex", function (selectedOption) {
      var _this$props = _this.props,
        valueKey = _this$props.valueKey,
        options = _this$props.options;

      // find selected option's index by value
      return options.map(function (opt) {
        return opt[valueKey];
      }).indexOf(selectedOption[valueKey]);
    });
    _this.state = {
      uuid: 'ssr-id'
    };
    return _this;
  }
  _inherits(Select, _React$Component2);
  return _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        uuid: generateUUID()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var uuid = this.state.uuid;
      var _this$props2 = this.props,
        async = _this$props2.async,
        creatable = _this$props2.creatable,
        htmlAttributes = _this$props2.htmlAttributes,
        searchable = _this$props2.searchable,
        selectComponent = _this$props2.selectComponent,
        _this$props2$id = _this$props2.id,
        id = _this$props2$id === void 0 ? uuid : _this$props2$id,
        instanceId = _this$props2.instanceId;
      var currentSelectComponent = selectComponent;
      if (!selectComponent) {
        if (creatable) {
          if (async) {
            currentSelectComponent = AsyncCreatable;
          } else {
            currentSelectComponent = Creatable;
          }
        }
      }
      return /*#__PURE__*/React.createElement(VirtualizedSelect, _extends({}, this.props, {
        onChange: this.handleOnChange,
        searchable: searchable || creatable,
        selectComponent: currentSelectComponent
      }, htmlAttributes, {
        instanceId: instanceId || id
      }));
    }
  }]);
}(React.Component);
_defineProperty(Select, "defaultProps", {
  async: false,
  autoFocus: false,
  clearable: false,
  creatable: false,
  htmlAttributes: {},
  labelKey: 'label',
  maxHeight: 200,
  menuContainerStyle: {},
  optionHeight: 36,
  searchable: false,
  valueKey: 'value'
});
Select.propTypes = {
  async: PropTypes.bool,
  autoFocus: PropTypes.bool,
  // autoFocus by default
  clearable: PropTypes.bool,
  // can reset value
  creatable: PropTypes.bool,
  // use <Creatable /> for custom tags
  htmlAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  labelKey: PropTypes.string,
  // attribute of option that contains the display text
  maxHeight: PropTypes.number.isRequired,
  menuContainerStyle: PropTypes.object,
  // custom dropdown styles
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.any,
    value: PropTypes.any,
    disabled: PropTypes.bool
  }).isRequired),
  optionHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,
  optionRenderer: PropTypes.func,
  searchable: PropTypes.bool,
  // can search a value
  selectComponent: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]))]),
  valueKey: PropTypes.string,
  // the option property to use for the value
  loadOptions: PropTypes.func,
  id: PropTypes.string,
  instanceId: PropTypes.string
};
export default Select;